import React from 'react';
import MainLayout from '../layout/MainLayout';

const AboutPage = () => {
  return (
    <MainLayout>
      <div>
        <h1>Über uns</h1>
        {/* Weitere Inhalte */}
      </div>
    </MainLayout>
  );
};

export default AboutPage;